import { createAsyncThunk } from "@reduxjs/toolkit";
import { downloadOrderCsv } from "../../services/services";

export const downloadCsvAsync = createAsyncThunk(
  "orders/downloadCsv",
  async (params, { rejectWithValue }) => {
    try {
      const blob = await downloadOrderCsv(params);
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "orders.csv");
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      return "success";
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
